import { render, staticRenderFns } from "./OrdenDetalleComponent.vue?vue&type=template&id=62a4ef69&scoped=true"
import script from "./OrdenDetalleComponent.vue?vue&type=script&lang=js"
export * from "./OrdenDetalleComponent.vue?vue&type=script&lang=js"
import style0 from "./OrdenDetalleComponent.vue?vue&type=style&index=0&id=62a4ef69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a4ef69",
  null
  
)

export default component.exports